import { useState } from 'react';
import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const MOCK_AI_FEED = [
  { action: 'Posted to LinkedIn: "5 Ways AI is Transforming..."', meta: 'TechStartup Inc', status: 'success', time: '2m ago' },
  { action: 'Sent 12 cold emails (Batch #47)', meta: 'E-Commerce Plus', status: 'success', time: '8m ago' },
  { action: 'Paused Google Ads (CPA exceeded limit)', meta: 'SaaS Ventures • Saved $340', status: 'warning', time: '15m ago' },
  { action: 'Generated 4 video clips from content', meta: 'TechStartup Inc', status: 'success', time: '23m ago' },
  { action: 'Qualified lead: John Smith (Score: 87)', meta: 'E-Commerce Plus', status: 'info', time: '45m ago' },
  { action: 'Budget reallocated: Google → Meta', meta: 'TechStartup Inc • +$2,400', status: 'success', time: '1h ago' },
];

const MOCK_COMPANIES = [
  { id: 'techstartup', name: 'TechStartup Inc', logo: 'TS', change: '+31%' },
  { id: 'ecommerce', name: 'E-Commerce Plus', logo: 'EC', change: '+18%' },
  { id: 'saas', name: 'SaaS Ventures', logo: 'SV', change: '+12%' },
];

const CEODashboard = () => {
  const [selectedCompany, setSelectedCompany] = useState('all');
  const [showDropdown, setShowDropdown] = useState(false);

  const heroMetrics = [
    { icon: '$', value: '$124,500', label: 'Total Revenue', change: '↑ 23%' },
    { icon: '⚡', value: '1,247', label: 'Leads Generated', change: '↑ 18%' },
    { icon: '◉', value: '$12,400', label: 'Ad Spend (83%)', change: '$15K budget' },
    { icon: '↗', value: '4.2x', label: 'Portfolio ROI', change: '↑ 0.3x' },
    { icon: '◈', value: '847', label: 'AI Actions Today', change: '24/7 active' },
    { icon: '✦', value: '156', label: 'Content Published', change: '↑ 12%' },
  ];

  return (
    <div className="lm-page">
      {/* CEO Header */}
      <div className="ceo-header">
        <div className="ceo-header-left">
          <div className="ceo-logo">Lazy Marketing</div>
          <div className="company-selector">
            <button
              className="company-selector-btn"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <div className="company-selector-icon">🏢</div>
              <div className="company-selector-text">
                <div className="company-selector-name">
                  {selectedCompany === 'all' ? 'All Companies' : MOCK_COMPANIES.find(c => c.id === selectedCompany)?.name}
                </div>
                <div className="company-selector-count">3 active companies</div>
              </div>
              <span className="company-selector-arrow">▼</span>
            </button>
            {showDropdown && (
              <div className="company-dropdown">
                <div className="company-dropdown-search">
                  <input type="text" placeholder="Search companies..." />
                </div>
                <div className="company-dropdown-list">
                  <div
                    className={`company-dropdown-item ${selectedCompany === 'all' ? 'active' : ''}`}
                    onClick={() => { setSelectedCompany('all'); setShowDropdown(false); }}
                  >
                    <div className="company-item-logo all">🏢</div>
                    <div className="company-item-info">
                      <div className="company-item-name">All Companies</div>
                      <div className="company-item-metric">Portfolio view</div>
                    </div>
                  </div>
                  {MOCK_COMPANIES.map(company => (
                    <div
                      key={company.id}
                      className={`company-dropdown-item ${selectedCompany === company.id ? 'active' : ''}`}
                      onClick={() => { setSelectedCompany(company.id); setShowDropdown(false); }}
                    >
                      <div className="company-item-logo">{company.logo}</div>
                      <div className="company-item-info">
                        <div className="company-item-name">{company.name}</div>
                        <div className="company-item-metric">{company.change} this week</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="ceo-header-right">
          <div className="notification-bell">
            🔔
            <span className="notification-badge">3</span>
          </div>
          <div className="notification-bell">👤</div>
        </div>
      </div>

      {/* Context Bar */}
      <div className="ceo-context-bar">
        <div className="context-left">
          <span className="context-viewing">Viewing: <strong>All Companies (3)</strong></span>
          <div className="time-selector">📅 Last 30 Days ▼</div>
        </div>
        <div className="system-health">
          <span className="health-dot"></span>
          All Systems Operational
        </div>
      </div>

      {/* Hero Metrics */}
      <div className="ceo-hero-metrics">
        {heroMetrics.map((metric, index) => (
          <div key={index} className="hero-metric-card">
            <div className="hero-metric-icon">{metric.icon}</div>
            <div className="hero-metric-value">{metric.value}</div>
            <div className="hero-metric-label">{metric.label}</div>
            <div className="hero-metric-change positive">{metric.change}</div>
          </div>
        ))}
      </div>

      {/* Widget Grid */}
      <div className="ceo-widget-grid">
        {/* AI Activity Feed */}
        <div className="ceo-widget widget-ai">
          <div className="ceo-widget-header">
            <div className="ceo-widget-title">🤖 AI Activity Feed</div>
            <span className="ceo-widget-action">View All</span>
          </div>
          <div className="ceo-widget-body">
            {MOCK_AI_FEED.map((item, index) => (
              <div key={index} className="ai-feed-item">
                <span className={`ai-feed-dot ${item.status}`}></span>
                <div className="ai-feed-content">
                  <div className="ai-feed-action">{item.action}</div>
                  <div className="ai-feed-meta">
                    <span>{item.meta}</span>
                    <span className="ai-feed-time">{item.time}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Budget Control */}
        <div className="ceo-widget widget-budget">
          <div className="ceo-widget-header">
            <div className="ceo-widget-title">💰 Budget Control</div>
            <span className="ceo-widget-action">Manage</span>
          </div>
          <div className="ceo-widget-body">
            <div className="budget-overview">
              <div className="budget-spent">$12,400</div>
              <div className="budget-total">of $15,000</div>
              <div className="budget-bar">
                <div className="budget-fill" style={{ width: '83%' }}></div>
              </div>
            </div>
            <div className="budget-breakdown">
              <div className="budget-item">
                <span className="budget-channel">Google Ads</span>
                <span className="budget-amount">$5,200</span>
              </div>
              <div className="budget-item">
                <span className="budget-channel">Meta Ads</span>
                <span className="budget-amount">$4,100</span>
              </div>
              <div className="budget-item">
                <span className="budget-channel">LinkedIn</span>
                <span className="budget-amount">$2,300</span>
              </div>
              <div className="budget-item">
                <span className="budget-channel">Email</span>
                <span className="budget-amount">$800</span>
              </div>
            </div>
          </div>
        </div>

        {/* Approval Queue */}
        <div className="ceo-widget widget-queue">
          <div className="ceo-widget-header">
            <div className="ceo-widget-title">📋 Approval Queue</div>
            <span className="ceo-widget-badge">2 pending</span>
          </div>
          <div className="ceo-widget-body">
            <div className="queue-item">
              <div className="queue-item-info">
                <div className="queue-item-type">Campaign</div>
                <div className="queue-item-name">Black Friday Sale 2024</div>
                <div className="queue-item-meta">TechStartup Inc • $2,500 budget</div>
              </div>
              <div className="queue-item-actions">
                <Button variant="primary" size="xs">Approve</Button>
                <Button variant="ghost" size="xs">Review</Button>
              </div>
            </div>
            <div className="queue-item">
              <div className="queue-item-info">
                <div className="queue-item-type">Content</div>
                <div className="queue-item-name">Weekly Newsletter Draft</div>
                <div className="queue-item-meta">E-Commerce Plus • 12,000 recipients</div>
              </div>
              <div className="queue-item-actions">
                <Button variant="primary" size="xs">Approve</Button>
                <Button variant="ghost" size="xs">Review</Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="ceo-quick-actions">
        <Button variant="primary" icon="plus">New Campaign</Button>
        <Button variant="secondary" icon="edit">Create Content</Button>
        <Button variant="secondary" icon="mail">Send Email</Button>
        <Button variant="secondary" icon="chart">View Reports</Button>
      </div>
    </div>
  );
};

export default CEODashboard;
